module.exports = __webpack_public_path__ + "img/electrical.52028761.svg";